import React from "react";
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from "@chakra-ui/react";

export default function CreateSceneModal({
  formErrors,
  handleFormChange,
  handleGenerateSubmit,
  handleSaveDraft,
  isGenerating,
  isOpen,
  onClose,
  sceneForm,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    handleGenerateSubmit(e);
  };

  const handleDraftSubmit = (e) => {
    e.preventDefault();
    handleSaveDraft(e);
  };

  return (
    <Modal
      closeOnEsc={!isGenerating}
      closeOnOverlayClick={!isGenerating}
      isOpen={isOpen}
      onClose={onClose}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Generate New Scene</ModalHeader>
        <ModalBody>
          <Box as="form" id="scene-form" onSubmit={handleSubmit}>
            <FormControl
              isDisabled={isGenerating}
              isInvalid={formErrors.title}
              isRequired
              mb={4}
            >
              <FormLabel>Scene title</FormLabel>
              <Input
                name="title"
                onChange={handleFormChange}
                placeholder="Enter scene title"
                value={sceneForm.title}
              />
              {formErrors.title ? (
                <FormErrorMessage>Title is required</FormErrorMessage>
              ) : null}
            </FormControl>

            <FormControl
              isDisabled={isGenerating}
              isInvalid={formErrors.prompt}
              isRequired
              mb={4}
            >
              <FormLabel>Prompt</FormLabel>
              <Textarea
                minHeight="200px"
                name="prompt"
                onChange={handleFormChange}
                placeholder="Describe your scene"
                value={sceneForm.prompt}
              />
              {formErrors.prompt ? (
                <FormErrorMessage>Prompt is required</FormErrorMessage>
              ) : null}
            </FormControl>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            isDisabled={isGenerating}
            mr={3}
            onClick={onClose}
            variant="ghost"
          >
            Cancel
          </Button>
          <Button
            colorScheme="gray"
            form="scene-form"
            isDisabled={isGenerating}
            mr={3}
            onClick={handleDraftSubmit}
          >
            Save as draft
          </Button>
          <Button
            colorScheme="blue"
            form="scene-form"
            isLoading={isGenerating}
            type="submit"
          >
            Generate
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
